import UserFooter from './UserFooter';

export { UserFooter };
